import { Logo } from 'palette/Logo';
import { Typography } from 'palette/Typography';
import CookiePolicyTrigger from '@common/CookiePolicy/components/CookiePolicyTrigger';
import { useTranslation } from '@common/Hooks/useTranslation';
import { FooterBackToTop } from '../components/FooterBackToTop';

import '../styles/FooterBottom.scss';

export function FooterBottom({
    subFooterLinks,
    securityShoppingIcons
}) {
    const translate = useTranslation();

    return (
        <div className="react-footer-bottom">
            <Typography
                color="light"
                type="small"
                weight="bold"
            >
                {translate('footer.verified_payments.label')}
            </Typography>
            <div className="react-footer-bottom__icons">
                {
                    securityShoppingIcons.map(({ icon, url }) => {
                        const LogoWrapper = url ? 'a' : 'span';

                        return (
                            <LogoWrapper
                                key={icon}
                                className="react-footer-bottom__icon"
                                {...url && {
                                    href: url,
                                    target: '_blank',
                                    'aria-label': icon,
                                    rel: 'noopener nofollow noreferrer'
                                }}
                            >
                                <Logo
                                    name={icon}
                                    size="medium"
                                />
                            </LogoWrapper>
                        );
                    })
                }
            </div>
            <div className="react-footer-bottom__links">
                {
                    subFooterLinks.children.map(item => (
                        <a
                            key={item.id}
                            className="react-footer-bottom__link"
                            href={item.navigationUrl}
                        >
                            {item.name}
                        </a>
                    ))
                }
                <CookiePolicyTrigger
                    cssClass="react-footer-bottom__link"
                    label={translate('footer.manage_cookies.label')}
                />
            </div>
            <Typography
                color="light"
                type="small"
            >
                ©
                {' '}
                {translate('footer.copy.shop_name.label')}
                {' '}
                {translate('footer.copy.all_rights_reserved.label')}
            </Typography>
            <FooterBackToTop />
        </div>
    );
}
